import {CreatePriceLevelConfigsField} from "../types/create-price-level-configs-field.types";
import {Validators} from "@angular/forms";

export const createPriceLevelConfigsFields: Array<CreatePriceLevelConfigsField> = [
  {
    label: 'Артикул',
    fieldName: 'article',
    type: 'select',
    validators: [ Validators.required ]
  },
  {
    label: 'Тип шага цены',
    fieldName: 'gapType',
    type: 'select',
    validators: [ Validators.required ]
  },
  {
    label: 'Шаг цены',
    fieldName: 'priceGap',
    type: 'number',
    validators: [ Validators.required ]
  },
  {
    label: 'Мин цена ур.1',
    fieldName: 'minPrice1',
    type: 'number'
  }
]
